import React, { useState, useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { addSubCategory, clearError, clearSuccess } from '../../../redux/Slices/AdminCategoriesSlice';

const AdminAddSubCategory = () => {
    const { setTitle } = useTitle();
    const { categoryId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const { updating, error, success } = useSelector((state) => state.adminCategories);
    
    const [formData, setFormData] = useState({
        name_ar: '',
        name_en: '',
        image: null,
        imagePreview: ''
    });
    const [imageLoading, setImageLoading] = useState(false);

    useEffect(() => {
        setTitle('إضافة فئة فرعية');
    }, [setTitle]);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearError());
        }
    }, [error, dispatch]);

    useEffect(() => {
        if (success) {
            toast.success(success);
            dispatch(clearSuccess());
            setTimeout(() => {
                navigate(`/admin-categories/${categoryId}/sub-categories`);
            }, 1500);
        }
    }, [success, dispatch, navigate, categoryId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = new FormData();
        payload.append('category_id', categoryId);
        payload.append('name_ar', formData.name_ar);
        payload.append('name_en', formData.name_en);
        if (formData.image) {
            payload.append('image', formData.image);
        }
        
        dispatch(addSubCategory(payload));
    };

    return (
        <div className="main_content">
            <div className="dashboard-container">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="btn btn-outline-secondary d-flex align-items-center"
                        onClick={() => navigate(`/admin-categories/${categoryId}/sub-categories`)}
                        style={{ borderRadius: '8px' }}>
                        <FaArrowLeft className="mx-2" />
                        العودة للفئات الفرعية
                    </motion.button>
                </div>

                {/* Add Form */}
                <div className="card shadow-lg border-0">
                    <div className="card-header">
                        <h5 className="mb-0">إضافة فئة فرعية</h5>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">الاسم بالعربية</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name_ar"
                                        value={formData.name_ar}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">الاسم بالإنجليزية</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name_en"
                                        value={formData.name_en}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">الصورة</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (!file) {
                                                setImageLoading(false);
                                                return;
                                            }
                                            
                                            setImageLoading(true);
                                            const previewUrl = URL.createObjectURL(file);
                                            
                                            // Wait for image to load
                                            const img = new Image();
                                            img.onload = () => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    image: file,
                                                    imagePreview: previewUrl
                                                }));
                                                setImageLoading(false);
                                            };
                                            img.onerror = () => {
                                                setImageLoading(false);
                                                toast.error('فشل في تحميل الصورة');
                                            };
                                            img.src = previewUrl;
                                        }}
                                        required
                                    />
                                    {formData.imagePreview && (
                                        <div className="mt-2 text-center">
                                            <img
                                                src={formData.imagePreview}
                                                alt="preview"
                                                style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: '12px' }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="d-flex gap-2 justify-content-center">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    onClick={() => navigate(`/admin-categories/${categoryId}/sub-categories`)}
                                    disabled={updating}>
                                    إلغاء
                                </button>
                                <button 
                                    type="submit" 
                                    className="btn text-white"
                                    style={{ backgroundColor: 'rgb(24, 65, 148)' }}
                                    disabled={updating || imageLoading || !formData.image}>
                                    {updating ? 'جاري الإضافة...' : imageLoading ? 'جاري تحميل الصورة...' : 'إضافة'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminAddSubCategory;

